import React from 'react';
import { IComponent } from '../../component';
import ImageTips from './ImageTips';
import ComponentLink from '../ComponentLink';

const AllForImageTips = function(props: IComponent) {
  return (
    <div className="all-for-tips">
      <ImageTips {...props} />
    </div>
  );
};

export default AllForImageTips;
